import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReviewerService } from '../../services/reviewer.service';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToastService } from '../../services/toast.service';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'app-verification-code',
    standalone: true,
    templateUrl: './verification-code.component.html',
    styleUrl: './verification-code.component.scss',
    imports: [CommonModule, ButtonModule, FormsModule, InputNumberModule],
})
export class VerificationCodeComponent {

  value!: number;
    
  constructor(private ref: DynamicDialogRef, 
    public config: DynamicDialogConfig, 
    private reviewerService: ReviewerService,
    private toast: ToastService
  ) { }

  closeDialog(){
    this.ref.close();
  }

  confirm() {
    this.reviewerService.updateEmail(this.config.data.email, this.value).subscribe({
      next: () => { this.ref.close(true); },
      error: () => {}
    });
  }
}
